// extracted by mini-css-extract-plugin
module.exports = {"score_interval_wrapper":"ScoreInterval_score_interval_wrapper__36LUO"};